

function html2canvas_adapt(node, options) {
	// https://github.com/niklasvh/html2canvas/blob/v1.4.1/docs/configuration.md
	options.allowTaint = true;
	options.useCORS = true;
	options.x = 0;
	options.y = 0;
	options.onclone = onElementClone;
	options.logging = true;
	// 支持自定义DPI（屏幕96DPI），不传则默认96
	if (options.dpi && !options.scale) {
		options.scale = options.dpi / 96;
	}
	html2canvas(node, options)
	.then(function (canvas) {
		if (options.onrendered) {
			options.onrendered(canvas);
		}
	});

	function onElementClone (element) {
	}
}
